//Listing calender API
export const getCalenderListApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/calendars${queryString ? `?${queryString}` : ''}`;
};

// GET Holiday list
export const getHolidayListApi = (params) => {
    return `calendars/${params?.calenderSlug}/holidays`;
};

// GET Holiday Rules
export const getHolidayRulesApi = (params) => {
    return `calendars/${params?.calenderSlug}/holiday_rules`;
};

// GET Calender detail endpoint (if you need slug)
export const getCalenderDetailApi = (params) => {
    return `calendars/${params.slug}`;
};

// POST API
export const addCalenderApi = () => {
    return `/calendars`;
};

// Post API for Holiday List
export const addHolidayListApi = (params) => {
    return `/calendars/${params?.calenderSlug}/holidays`;
    
};

// Post API for Holiday Rule
export const addHolidayRulesApi = (params) => {
    return `/calendars/${params?.calenderSlug}/holiday_rules`;
    
};

// Put API for Holiday List
export const updateHolidayListApi = (params) => {
    return `/calendars/${params?.calenderSlug}/holidays/${params?.holiday_slug}`;
};

// Put API for Holiday Rules
export const updateHolidayRulesApi = (params) => {
    return `/calendars/${params?.calenderSlug}/holiday_rules/${params?.holiday_slug}`;
};

// PUT edit API
export const updateCalenderApi = (params) => {
    return `/calendars/${params?.calender_slug}`;
};

// DELETE API
export const deleteCalenderApi = () => {
    return `/calendars`;
};

// DELETE API Holiday List
export const deleteHolidayListApi = (params) => {
    return `/calendars/${params?.calenderSlug}/holidays`;
};

// DELETE API Holiday Rules
export const deleteHolidayRulesApi = (params) => {
    return `/calendars/${params?.calenderSlug}/holiday_rules`;
};

// EXPORT API
export const exportCalenderApi = (leaseId) => {
    return `lease/${leaseId}/parties`;
};

// import holiday list api
export const calenderFileImport = (params) => {
    return `/calendars/${params?.calenderSlug}/holidays/import`
}

// download sample api holiday
export const calenderSampleFile = (params) => {
    return `/calendars/${params?.calenderSlug}/holidays/download_template`
}
